<template>
  <div class="personage-page">
    <div class="page-title">
      <span>个人信息</span>
    </div>
    <div class="page-content">
      <div class="head-box">
        <div :class="['head-img', {'pointer': userInfo.head_photo}]" v-loading="uploadLoading"  @click="funPreImg">
          <img :src="userInfo.head_photo || userImg" alt="">
        </div>
        <el-upload ref="upload"
                   action="/ajax/common/interface/image/upload"
                   :headers="headerData"
                   :show-file-list="false"
                   name="image"
                   accept="image/jpg, image/jpeg, image/png"
                   :before-upload="beforeFileUpload"
                   :on-success="uploadSuccess"
                   :on-error="uploadError">
          <div class="upload-head-box">
            <i class="icon-upload"></i>上传头像
          </div>
        </el-upload>
      </div>
      <div class="from-box star-float">
        <el-form ref="personageForm"
                 class="form-content"
                 :model="userInfo"
                 label-position="left"
                 label-width="110px">
          <el-form-item label="用户名">
            <span>{{userInfo.account}}</span>
          </el-form-item>
          <el-form-item label="注册手机">
            <span>{{userInfo.reg_mobile}}</span>
            <!--<span class="text-warning ml pointer" @click="showSelectDialog(1)">修改</span>-->
          </el-form-item>
          <el-form-item label="注册邮箱">
            <span>{{userInfo.email}}</span>
            <!--<span class="text-warning ml pointer" @click="showSelectDialog(2)">修改</span>-->
          </el-form-item>
          <el-form-item label="性别">
            <el-select class="width-full" v-model="userInfo.sex" placeholder="请选择" clearable>
              <el-option v-for="item in $config.sexList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生日">
            <el-date-picker class="width-full" v-model="userInfo.birthday" type="date" 
                            placeholder="请选择" value-format="yyyy-MM-dd" :picker-options="birthdayOpt">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="教育程度">
            <el-select class="width-full" v-model="userInfo.education" placeholder="请选择" clearable>
              <el-option v-for="item in $config.educationList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="婚姻状况">
            <el-select class="width-full" v-model="userInfo.marriage" placeholder="请选择" clearable>
              <el-option v-for="item in $config.marriageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model.trim="userInfo.name" maxlength="30" clearable placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="identity_card" :rules="rules.identity_card">
            <el-input v-model="userInfo.identity_card" maxlength="18" clearable placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="所在行业">
            <el-select class="width-full" v-model="userInfo.industry_id" placeholder="请选择" clearable>
              <el-option v-for="item in industryList" :key="item.id" :label="item.industry_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-button class="submit-btn" @click="funUpdateInfo">更新信息</el-button>
        </el-form>
      </div>
    </div>
  
    <!--修改注册手机号/注册邮箱选择弹窗-->
    <el-dialog width="840px" 
               :title="editType === 1 ? '修改注册手机' : '修改注册邮箱'"
               :visible.sync="selectDialogShow" >
      <div class="select-content">
        <div class="select-tips">请选择验证方式</div>
        <div class="btn-box">
          <div class="btn-item" @click="showEditDialog(1)">手机验证</div>
          <div class="btn-item ml-lg" @click="showEditDialog(2)">邮箱验证</div>
        </div>
      </div>
    </el-dialog>

    <!--修改注册手机号/注册邮箱选择弹窗-->
    <el-dialog width="840px"
               :title="editType === 1 ? '修改注册手机' : '修改注册邮箱'"
               :visible.sync="editDialogShow">
      <div class="edit-content">
        <hll-steps :steps-list="stepsList" :step-index="curStep"></hll-steps>
        <el-form ref="editFrom1" v-if="curStep === 0"
                 class="edit-form-box large-form"
                 :model="editInfo"
                 :rules="rules"
                 label-position="left"
                 label-width="0">
          <el-form-item label="" prop="area_name">
            <el-input v-model="editInfo.area_name" maxlength="4" clearable 
                      :placeholder="checkType === 1 ? '请输入原注册手机号' : '请输入原注册邮箱'">
              <i slot="prefix" :class="['input-icon', checkType === 1 ? 'input-icon-phone' : 'input-icon-email']"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="area_name"  class="input-code-item">
            <el-input v-model="editInfo.area_name" maxlength="4" clearable placeholder="请输入验证码">
              <i slot="prefix" class="input-icon input-icon-password"></i>
            </el-input>
            <div class="input-code-box text-warning pointer">获取验证码</div>
          </el-form-item>
          <el-button class="edit-submit-btn">下一步</el-button>
        </el-form>
        <el-form ref="editFrom2" v-if="curStep === 1"
                 class="edit-form-box large-form"
                 :model="editInfo"
                 :rules="rules"
                 label-position="left"
                 label-width="0">
          <el-form-item label="" prop="area_name">
            <el-input v-model="editInfo.area_name" maxlength="4" clearable
                      :placeholder="checkType === 1 ? '请输入新手机号' : '请输入新邮箱'">
              <i slot="prefix" :class="['input-icon', checkType === 1 ? 'input-icon-phone' : 'input-icon-email']"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="area_name" class="input-code-item">
            <el-input v-model="editInfo.area_name" maxlength="4" clearable placeholder="请输入验证码">
              <i slot="prefix" class="input-icon input-icon-password"></i>
            </el-input>
            <div class="input-code-box text-warning pointer">获取验证码</div>
          </el-form-item>
          <el-button class="edit-submit-btn">下一步</el-button>
        </el-form>
        <div class="edit-form-box text-center" v-if="curStep === 2">
          <div class="result-box text-left">
            <div class="result-titlte">{{editType === 1 ? '手机号更换成功！' : '邮箱更换成功！'}}</div>
          </div>
          <el-button class="edit-submit-btn disabled">返回</el-button>
        </div>
      </div>
    </el-dialog>

    <!--图片预览弹窗-->
    <img-preview v-model="imgPreviewShow" :data="userInfo.head_photo"></img-preview>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import userImg from "../../assets/img/index/user_avatar.png";
  import HllSteps from '../common/hll-steps'
  import ImgPreview from '../common/hll-img-preview'
  
  export default {
    name: 'personage',
    data() {
      let identityCheck = (rule, value, callback) => {
        if (value && !this.$config.regCommon.identityCard.test(value)) {
          callback(new Error('请输入正确的身份证号码'));
        } else {
          callback();
        }
      }
      return {
        headerData: {
          Authorization: localStorage.getItem('token')
        },
        userImg: userImg,
        userInfo: {
          account: '',
          reg_mobile: '',
          email: '',
          sex: '',
          birthday: null,
          education: '',
          marriage: '',
          name: '',
          head_photo: '',
          identity_card: '',
          industry_id: '',
        },
        imgPreviewShow: false,
        uploadLoading: false,
        industryList: [],
        selectDialogShow: false,
        editDialogShow: false,
        editType: 1, // 1 手机号码 2 邮箱 
        checkType: 1, // 1 手机号码 2 邮箱 
        curStep: 0,
        editInfo: {
          
        },
        rules: {
          identity_card: [
            {validator: identityCheck, trigger: 'blur'}
          ],
        },
        birthdayOpt: {
          disabledDate(value) {
            let timeNow = new Date().getTime()
            return value > timeNow
          }
        }
      }
    },
    computed: {
      userStoreInfo() {
        return this.$store.state.app.userInfo
      },
      stepsList() {
        return this.editType === 1 
          ? ['验证原注册手机号', '设置新手机号', '设置成功']
          : ['验证原注册邮箱', '设置新邮箱', '设置成功']
      },
    },
    components: {
      HllSteps,
      ImgPreview
    },
    mounted() {
      if(this.userStoreInfo && this.userStoreInfo.reg_mobile) {
        this.setUserInfo()
      }
      this.getIndustryList()
    },
    watch: {
      userStoreInfo(newVal) {
        this.setUserInfo()
      }
    },
    methods: {
      ...mapActions(['getUserInfo']),
      // 从store中获取用户信息
      setUserInfo() {
        Object.assign(this.userInfo, this.userStoreInfo)
        this.userInfo.dev_id = this.userInfo.id
      },
      // 图片预览
      funPreImg() {
        if(this.userInfo.head_photo) {
          this.imgPreviewShow = true;
        }
      },
      beforeFileUpload(file) {
        let isValid = true;
        let strArr = file.name.split('.');
        let type = strArr[strArr.length - 1].toLowerCase();
        if (file.size / 1024 / 1024 > 2) {
          isValid = false;
          this.$message.error('图片不能大于2M');
        }
        if(['jpeg', 'jpg', 'png'].indexOf(type) === -1) {
          isValid = false;
          this.$message.error('图片格式仅支持 JPEG、JPG、PNG');
        }
        isValid && (this.uploadLoading1 = true);
        return isValid;
      },
      uploadSuccess(res, file) {
        this.uploadLoading = false
        if (res.ret === 0) {
          this.userInfo.head_photo = res.data
        } else {
          this.$refs.upload.clearFiles()
        }
      },
      uploadError(res, file) {
        this.uploadLoading = false
        this.$message.error('上传头像失败')
      },
      // 获取行业信息
      getIndustryList() {
        this.$axios.get("/ajax/person/center/industry/list").then(res => {
          this.industryList = res.data.data;
        });
      },
      // 提交更新
      funUpdateInfo() {
        if(this.isLoading) {
          return
        }
        this.$refs.personageForm.validate(valid => {
          if (valid) {
            this.showCommonLoading()
            this.$axios.post("/ajax/person/center/user/update", this.userInfo).then(res => {
              this.hideCommonLoading();
              if (res.data.ret === 0) {
                this.$message.success('更新信息成功');
                this.getUserInfo() // 同步store信息
              }
            }).catch(e => {
              this.hideCommonLoading();
            });
          }
        })
      },
      // 展示选择修改手机号码/邮箱时的验证方式
      showSelectDialog(type) {
        this.editType = type
        this.selectDialogShow = true
      },
      // 展示编辑修改手机号码/邮箱弹窗
      showEditDialog(type) {
        this.selectDialogShow = false
        this.checkType = type
        this.editDialogShow = true
      },
    }
  }
</script>

<style lang="scss">
  .personage-page {
    .form-content {
      .el-form-item__label {
        font-size: 16px;
      }
      .el-form-item__content {
        font-size: 16px;
        color: #212121;
      }
    }
    .el-upload--picture-card:hover, 
    .el-upload:focus {
      border-color: unset;
      color: unset;
    }
  }
</style>
<style lang="scss" scoped>
  .personage-page {
    width: 1169px;
    padding: 0 0 30px;
    margin: 0 auto;
    .page-title {
      width: 100%;
      height: 32px;
      line-height: 32px;
      font-size: 24px;
      color: #212121;
      text-align: center;
      position: relative;
      margin: 24px 0;
    }
    .page-content {
      width: 100%;
      background: #fff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      position: relative;
    }
    .head-box {
      position: absolute;
      top: 30px;
      left: 70px;
      width: 156px;
      height: auto;
      color: #666;
      text-align: center;
      .head-img {
        width: 156px;
        height: 156px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
        }
      }
      .upload-head-box {
        width: 110px;
        height: 34px;
        line-height: 34px;
        border: 1px solid #ccc;
        border-radius: 2px;
        margin: 20px auto;
      }
      .icon-upload {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 5px;
        background: url("../../assets/img/account/icon_upload.png");
        background-size: 100% 100%;
        position: relative;
        top: 1px;
      }
    }
    .from-box {
      width: 100%;
      padding: 30px 0 56px 337px;
      box-sizing: border-box;
      .form-content {
        width: 480px;
      }
    }
    .submit-btn {
      width: 100%;
      height: 40px;
      background: #F16222;
      font-size: 14px;
      color: #fff;
      border: none;
      font-weight: normal;
      margin-top: 40px;
      &.disabled {
        background: rgba(241, 98, 34, .35);
      }
    }
    .forget-box {
      margin-top: 15px;
      padding-left: 5px;
      font-size: 12px;
      text-align: right;
    }
  }
  .select-content {
    padding: 30px 20px;
    text-align: center;
    box-sizing: border-box;
    .select-tips {
      color: #424456;
      font-size: 20px;
    }
    .btn-box {
      margin-top: 24px;
      margin-bottom: 42px;
      .btn-item {
        display: inline-block;
        width: 110px;
        height: 34px;
        line-height: 34px;
        color: #F16222;
        border: 1px solid #F16222;
        border-radius: 2px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .edit-content {
    padding: 28px 53px 40px;
    .edit-form-box {
      width: 430px;
      margin: 69px auto;
    }
    .edit-submit-btn {
      width: 100%;
      height: 48px;
      background: #F16222;
      font-size: 18px;
      color: #fff;
      border: none;
      font-weight: normal;
      &.disabled {
        background: rgba(241, 98, 34, .35);
      }
    }
  }
  .result-box {
    display: inline-block;
    width: auto;
    height: 80px;
    background: url("../../assets/img/account/icon_success.png") no-repeat left center;
    background-size: 80px 80px;
    padding-left: 134px;
    margin: 33px auto 87px;
    box-sizing: border-box;
    .result-titlte {
      color: #424456;
      font-size: 22px;
      line-height: 30px;
      padding-top: 25px;
      margin-bottom: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/account/personage.vue